import { HealthcareFacilityUnit } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { Translate, useFormController } from '@dreryk/react-common';
import { StyledFlex } from '@dreryk/react-components';

import { statisticsTranslationKeys } from '../../translations';

import { GenerateZD3FormBean, GenerateZD3FormController } from './GenerateZD3Form.types';
import { ReportingPeriodSelect } from './fields/ReportingPeriodSelect';
import { HealthcareFacilityUnitSelect } from './fields/HealthcareFacilityUnitSelect';
import { IncludeVisitsFinishedNotApprovedCheckbox } from './fields/IncludeVisitsFinishedNotApprovedCheckbox';
import { IncludeVisitsInProgressCheckbox } from './fields/IncludeVisitsInProgressCheckbox';

type GenerateZD3FormRenderProps = Pick<GenerateZD3FormController, 'handleSubmit' | 'formState'>;

type GenerateZD3FormProps = {
   readonly healthcareFacilityUnits: HealthcareFacilityUnit[];
   readonly children: (renderProps: GenerateZD3FormRenderProps) => JSX.Element;
};

export const GenerateZD3Form = (props: GenerateZD3FormProps): JSX.Element => {
   const { register, handleSubmit, formState } = useFormController<GenerateZD3FormBean>({
      year: new Date().getFullYear() - 1,
      healthcareFacilityUnit: props.healthcareFacilityUnits.length === 1 ? props.healthcareFacilityUnits[0] : null,
   });

   return (
      <StyledFlex as={'form'} direction={'column'} gap={'24px'}>
         <Translate>{statisticsTranslationKeys.modal.type.healthcareProviderZD3}</Translate>

         <ReportingPeriodSelect register={register} />
         <HealthcareFacilityUnitSelect register={register} healthcareFacilityUnits={props.healthcareFacilityUnits} />
         <IncludeVisitsFinishedNotApprovedCheckbox register={register} />
         <IncludeVisitsInProgressCheckbox register={register} />

         {props.children({
            handleSubmit: handleSubmit,
            formState: formState,
         })}
      </StyledFlex>
   );
};
